module.exports = __webpack_public_path__ + "b83b1bf3b41e7fc91969c91ecfe3c148.pdf";